import React from 'react';
import styled from 'styled-components';

import { CurrencyFormat } from '@lt/components';
import { NBSP } from 'src/constants/common';

import { TEXT } from '../../constants';
import { Title } from '../../styles';
import { SearchTypeIcon } from '../SearchTypeIcon';

import type { TitleProps } from '../../types';

type TitleLoadedProps = Omit<TitleProps, 'isLoaded'>;

export const TitleLoaded = (props: TitleLoadedProps) => {
  const { destinationText, price, currencyCode, type, isMobile, className } =
    props;

  const { tourType } = TEXT[type];

  return (
    <Title className={className} $isMobile={isMobile}>
      {`${tourType} ${destinationText} `}

      <PriceWrapper>
        {price && (
          <CurrencyFormat
            value={price}
            currencyCode={currencyCode}
            prefix={`от${NBSP}`}
          />
        )}

        <SearchTypeIcon searchType={type} />
      </PriceWrapper>
    </Title>
  );
};

const PriceWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;
